import { IS_DEV_MODE } from '@/constants/envs'

export function logInDev(...args: Parameters<typeof console.log>) {
  if (!IS_DEV_MODE) {
    return
  }

  console.log(...args)
}
